import DefaultContainer from '../containers/DefaultContainer'
import ResponseComponentLayout from '../containers/ResponseComponentLayout'
import CommandResponseTemplate from '@/views/CommandResponse/CommandResponseTemplate.vue'
import CommandResponseType from '@/views/CommandResponse/CommandResponseType.vue'
import CommandResponseOptions from '@/views/CommandResponse/CommandResponseOptions.vue'
import CommandResponseFallback from '@/views/CommandResponse/CommandResponseFallback.vue'
import CommandExtraOptions from '@/views/CommandResponse/CommandExtraOptions.vue'
import CommandUserData from '@/views/CommandResponse/CommandUserData.vue'
import CommandResponseActions from '@/views/CommandResponse/CommandResponseActions.vue'
import CommandAdvertises from '@/views/CommandResponse/CommandAdvertises.vue'

import Dashboard from '../views/Dashboard'
import Page404 from '../views/Page404'

import Login from '../views/user/Login'
import Logout from '../views/user/Logout'
import Register from '../views/user/Register'
import SocialRegister from '../views/user/SocialRegister'
import Account_Activation from '../views/user/Account_Activation'
import Validate_Remember_Password from '../views/user/Validate_Remember_Password'

import chatbotForm from '../views/chatbots/form'
import serviceList from '../views/services/list'
import commandList from '../views/commands/list'
import commandInfo from '../views/commands/form-info'
import variableForm from '../views/commands/variables/form'
import variableList from '../views/commands/variables/list'
import exampleForm from '../views/commands/examples/form'
import responseForm from '../views/commands/response'

import advertisesForm from '../views/commands/advertises/form'
import subsSend from '../views/subscriptions/send'
import subsForm from '../views/subscriptions/form'
import subsList from '../views/subscriptions/list'
import DSForm from '../views/datasets/form'
import DSList from '../views/datasets/list'
import DSData from '../views/datasets/list_data'
import MenusForm from '../views/menus/form'
import MenusList from '../views/menus/list'
import MenusData from '../views/menus/list_data'
import MenusOrder from '../views/menus/list_order'
import DataSourceForm from '../views/datasource/form'
import DataSourceList from '../views/datasource/list'
import Settings from '../views/settings/form'
import simpleScenario from '../views/simpleScenario/form'
import _debugger from '../views/debugger/form'
import autocomplete from '../views/autocomplete/form'
import GooglePlaces from '@/views/dev/places.vue'
import MapsList from '@/views/maps/list';
import MapsForm from '@/views/maps/form';
import LocationsList from '@/views/locations/list';
import LocationsForm from '@/views/locations/form';

export default {
	mode: 'hash', // Demo is living in GitHub.io, so required!
	linkActiveClass: 'open active',
	scrollBehavior: () => ({
		y: 0,
	}),
	routes: [
		{
			path: '/user',
			redirect: '/user/login',
			name: 'User',
			component: {
				render(c) {
					return c('router-view')
				},
			},
			children: [
				{
					path: 'login',
					name: 'Login',
					component: Login,
					meta: {
						is_login: false,
					},
				},
				{
					path: 'register',
					name: 'Register',
					component: Register,
					meta: {
						is_login: false,
					},
				},
				{
					path: 'social_register/:token',
					name: 'Socaial Register',
					component: SocialRegister,
					meta: {
						is_login: false,
					},
				},
				{
					path: 'activate_account/:user_id/:code',
					name: 'Activate Your Account',
					component: Account_Activation,
					meta: {
						is_login: false,
					},
				},
				{
					path: 'validate_remember_password',
					name: 'Validate Your Password',
					component: Validate_Remember_Password,
					meta: {
						is_login: false,
					},
				},
				{
					path: 'logout',
					name: 'Logout',
					component: Logout,
					meta: {
						is_login: true,
					},
				},
			],
		},

		{
			path: '/',
			redirect: '/dashboard',
			name: 'Home',
			component: DefaultContainer,
			meta: {
				is_login: true,
			},
			children: [
				{
					path: 'dev/google-places',
					component: GooglePlaces,
				},
				{
					path: 'autocomplete',
					name: 'autocomplete',
					component: autocomplete,
					meta: {
						is_login: true,
					},
				},
				{
					path: 'debugger',
					name: 'debugger',
					component: _debugger,
					meta: {
						is_login: true,
					},
				},
				{
					path: 'dashboard',
					name: 'Dashboard',
					component: Dashboard,
					meta: {
						is_login: true,
					},
				},

				{
					path: 'simple_scenario',
					name: 'Scenario',
					component: simpleScenario,
					meta: {
						is_login: true,
					},
				},

				{
					path: 'scenario',
					name: 'Simple Scenario',
					component: simpleScenario,
					meta: {
						is_login: true,
					},
				},

				{
					path: 'settings',
					name: 'Settings',
					component: Settings,
					meta: {
						is_login: true,
					},
				},
				{
					path: 'chatbot',
					redirect: '/chatbot',
					name: 'chatbot',
					meta: {
						is_login: true,
					},
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: '',
							name: '',
							component: chatbotForm,
							meta: {
								is_login: true,
							},
						},
					],
				},
				{
					path: 'subscription',
					redirect: '/subscription',
					name: 'subscription',
					meta: {
						is_login: true,
					},
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: '',
							component: subsList,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id',
							name: 'about',
							redirect: ':id/about',
						},
						{
							path: ':id/about',
							// name: 'about',
							component: subsForm,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id/send',
							name: 'Send',
							component: subsSend,
							meta: {
								is_login: true,
							},
						},
					],
				},
				{
					path: 'dataset',
					redirect: '/dataset',
					name: 'dataset',
					meta: {
						is_login: true,
					},
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: '',
							component: DSList,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id',
							redirect: ':id/structure',
						},
						{
							path: ':id/structure',
							name: 'Dataset structure',
							component: DSForm,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id/data',
							name: 'Datasets data',
							component: DSData,
							meta: {
								is_login: true,
							},
						},
					],
				},

				{
					path: 'menus',
					redirect: '/menus',
					name: 'menus',
					meta: {
						is_login: true,
					},
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: '',
							component: MenusList,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id',
							redirect: ':id/structure',
						},
						{
							path: ':id/structure',
							name: 'menus structure',
							component: MenusForm,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id/data',
							name: 'menus data',
							component: MenusData,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id/orders',
							name: 'menu orders',
							component: MenusOrder,
							meta: {
								is_login: true,
							},
						},
					],
				},
				{
					path: 'datasources',
					redirect: '/datasources',
					name: 'datasources',
					meta: {
						is_login: true,
					},
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: '',
							component: DataSourceList,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id',
							name: 'Data sources',
							component: DataSourceForm,
							meta: {
								is_login: true,
							},
						},
					],
				},
				{
					path: 'services',
					redirect: '/services',
					name: 'Services',
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: '',
							name: '',
							component: serviceList,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id',
							name: '%1Service',
							meta: {
								is_login: true,
							},
							redirect: ':id/commands',
						},

						{
							path: ':service_id/commands',
							redirect: '/services/:service_id/commands',
							name: 'Commands',
							meta: {
								is_login: true,
							},
							component: {
								render(c) {
									return c('router-view')
								},
							},
							children: [
								{
									path: '',
									name: '',
									component: commandList,
									meta: {
										is_login: true,
									},
								},
								{
									path: ':command_id',
									redirect: '/services/:service_id/commands/:command_id/about',
									name: 'command.about',
									meta: {
										is_login: true,
									},
									component: {
										render(c) {
											return c('router-view')
										},
									},
								},
								{
									path: ':command_id/about',
									redirect: '/services/:service_id/commands/:command_id/about',
									// name: 'about',
									meta: {
										is_login: true,
									},
									component: {
										render(c) {
											return c('router-view')
										},
									},
									children: [
										{
											path: '',
											name: '',
											component: commandInfo,
											meta: {
												is_login: true,
											},
										},
									],
								},
								{
									path: ':command_id/variables',
									redirect: '/services/:service_id/commands/:command_id/variables',
									name: 'variables',
									meta: {
										is_login: true,
									},
									component: {
										render(c) {
											return c('router-view')
										},
									},
									children: [
										{
											path: '',
											name: '',
											component: variableList,
											meta: {
												is_login: true,
											},
										},
										{
											path: ':variable_id',
											name: '%1Variable',
											component: variableForm,
											meta: {
												is_login: true,
											},
										},
									],
								},
								{
									path: ':command_id/examples',
									redirect: '/services/:service_id/commands/:command_id/examples',
									name: 'Examples',
									meta: {
										is_login: true,
									},
									component: {
										render(c) {
											return c('router-view')
										},
									},
									children: [
										{
											path: '',
											name: '',
											component: exampleForm,
											meta: {
												is_login: true,
											},
										},
									],
								},
								{
									path: ':command_id/response',
									redirect: '/services/:service_id/commands/:command_id/response',
									name: 'Response',
									component: {
										render(c) {
											return c('router-view')
										},
									},
									meta: {
										is_login: true,
									},
									children: [
										{
											path: '',
											name: '',
											component: responseForm,
											meta: {
												is_login: true,
											},
										},
									],
								},

								{
									path: ':command_id/result/',
									redirect: '/services/:service_id/commands/:command_id/result/type',
									name: 'result',
									component: ResponseComponentLayout,
									meta: {
										is_login: true,
									},
									children: [
										{
											path: 'type',
											name: '',
											component: CommandResponseType,
											meta: {
												is_login: true,
											},
										},
										{
											path: 'template/:response_type?',
											name: '',
											component: CommandResponseTemplate,
											meta: {
												is_login: true,
											},
										},
										{
											path: 'options/:response_type?',
											name: '',
											component: CommandResponseOptions,
											meta: {
												is_login: true,
											},
										},
										{
											path: 'fallback',
											name: '',
											component: CommandResponseFallback,
											meta: {
												is_login: true,
											},
										},
										{
											path: 'extra-options',
											name: '',
											component: CommandExtraOptions,
											meta: {
												is_login: true,
											},
										},
										{
											path: 'user-data',
											name: '',
											component: CommandUserData,
											meta: {
												is_login: true,
											},
										},
										{
											path: 'response-actions',
											name: '',
											component: CommandResponseActions,
											meta: {
												is_login: true,
											},
										},
										{
											path: 'advertises',
											name: '',
											component: CommandAdvertises,
											meta: {
												is_login: true,
											},
										},
									],
								},

								{
									path: ':command_id/advertises',
									redirect: '/services/:service_id/commands/:command_id/advertises',
									name: 'advertises',
									component: {
										render(c) {
											return c('router-view')
										},
									},
									meta: {
										is_login: true,
									},
									children: [
										{
											path: '',
											name: '',
											component: advertisesForm,
											meta: {
												is_login: true,
											},
										},
									],
								},
							],
						},
					],
				},
				{
					path: 'maps',
					redirect: '/maps',
					name: 'maps',
					meta: {
						is_login: true,
					},
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: '',
							name: 'Maps list',
							component: MapsList,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':id',
							name: 'Maps form',
							component: MapsForm,
							meta: {
								is_login: true,
							},
						},
					],
				},
				{
					path: 'locations',
					redirect: '/locations',
					name: 'locations',
					meta: {
						is_login: true,
					},
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: ':map',
							name: 'Locations list',
							component: LocationsList,
							meta: {
								is_login: true,
							},
						},
						{
							path: ':map/:id',
							name: 'Locations form',
							component: LocationsForm,
							meta: {
								is_login: true,
							},
						},
					],
				},
			],
        },

		{
			path: '/404',
			component: Page404,
		},
		{
			path: '*',
			redirect: '/404',
		},
	],
}
